import { Outlet } from "react-router-dom";
import Brand from "../../brand/brand.component";
import BrandFullName from "../../brand_fullname/brand_fullname.component";
import "./customer-navigation.styles.scss";
const CustomerNavigation = () => {
  return (
    <div className="customer-navigation-container">
      {window.innerWidth > 1024 ? (
        <div className="customer-navigation-desktop">
          <div className="cn-top">
            <BrandFullName />
          </div>

          <Outlet />
        </div>
      ) : (
        <div className="customer-navigation-mobile">
          <div className="cn-top">
            <Brand />
          </div>

          <Outlet />
        </div>
      )}
    </div>
  );
};
export default CustomerNavigation;
